
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M17.3 6.3a1 1 0 00-1.41 0l-5.64 5.64 1.41 1.41L17.3 7.7a1 1 0 000-1.4zm4.24-.01l-9.88 9.88-3.48-3.47a1 1 0 00-1.41 1.41l4.18 4.18a1 1 0 001.41 0L22.95 7.71a1 1 0 000-1.41h-.01a.975.975 0 00-1.4-.01zM1.12 14.12L5.3 18.3a1 1 0 001.41 0l.7-.7-4.88-4.9a1 1 0 00-1.41 0 1.008 1.008 0 000 1.42z"}})])
          )
        }
      }
    